"use client";

import { useConsentStore } from "@/app/stores/consent-store";

export default function CookieFab() {
  const { setCustomizeOpen, setBannerOpen } = useConsentStore();

  return (
    <button
      type="button"
      aria-label="Cookie-Einstellungen öffnen"
      onClick={() => {
        setBannerOpen(false);
        setCustomizeOpen(true);
      }}
      className="cursor-pointer text-xs"
    >
      Cookie-Einstellungen
    </button>
  );
}
